import {
  Add,
  Button,
  FormCard,
  FormItem,
  Input,
  TextArea,
  Trash,
  theme
} from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Form as AntdForm } from 'antd'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import { DeleteButtonText } from 'screens/Residents/screens/ResidentProfileScreen/styledComponents'

export const AdvancedStatementsFormCard = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  return (
    <AntdForm.List name="advancedStatements">
      {(fields, { add, remove }) => (
        <FormCard
          title={t(supConstants.ADVANCED_STATEMENTS)}
          rightChildren={
            <Button
              type="button"
              variant="text"
              icon={<Add />}
              onClick={() => add()}
            >
              {t(supConstants.ADD_ADVANCED_STATEMENT)}
            </Button>
          }
        >
          {fields.map((field, i) => (
            <FormCard
              level={2}
              key={field.name}
              title={`${t(supConstants.ADVANCED_STATEMENT)} ${i + 1}`}
              rightChildren={
                <Button
                  type="button"
                  variant="text"
                  icon={<Trash color={theme.color.neutral.color4} />}
                  onClick={() => remove(field.name)}
                >
                  <DeleteButtonText>{t(supConstants.DELETE)}</DeleteButtonText>
                </Button>
              }
            >
              <FormItem
                label={<Text>{t(supConstants.TITLE)}</Text>}
                name={[field.name, 'title']}
                key={['advancedStatements', field.key, 'title'].join('-')}
                rules={[
                  {
                    required: true,
                    message: `${t(supConstants.PLEASE_ENTER)} ${t(
                      supConstants.TITLE
                    )}`
                  }
                ]}
              >
                <Input maxLength={100} />
              </FormItem>
              <FormItem
                label={<Text>{t(supConstants.DESCRIPTION)}</Text>}
                name={[field.name, 'description']}
                key={['advancedStatements', field.key, 'description'].join('-')}
              >
                <TextArea
                  autoSize={{
                    minRows: 3
                  }}
                />
              </FormItem>
            </FormCard>
          ))}
        </FormCard>
      )}
    </AntdForm.List>
  )
}
